// extracted by mini-css-extract-plugin
export var sliderRange = "_dq-2";
export var sliderRoot = "_dq-0";
export var sliderThumb = "_dq-3";
export var sliderTrack = "_dq-1";